import { Text } from "@ecco/ui/text";

export interface IPaymentMessage {
    message: string;
    color?: string;
    mb: number;
    mt?: number;
}
export function PaymentMessage({ message, color, mb, mt }: IPaymentMessage) {
    return (
        <Text
            fontWeight="bold"
            color={color ? color : undefined}
            fontSize={["desktopBodyTextSmall", "desktopBodyTextNormal"]}
            mb={mb}
            mt={mt}
        >
            {message}
        </Text>
    );
}
PaymentMessage.displayName = "PaymentMessage";
export default PaymentMessage;
